import React, { useState, useEffect } from 'react';
import styles from './style.module.scss';
import Modal from '../../../../../components/modal/index';
import TagInput from '../../../../../components/form/tag-input';
import { Formik } from 'formik';
import * as Yup from "yup";
import { mccBulkUpdate, ListOfPdfs } from '../../../../../../api';
import ButtonIcon from '../../../../../components/ButtonIcon/ButtonIcon';
import useMccStore from '../../../../../stores/mcc';
import toast from 'react-hot-toast';
import InfoIcon from '../../../../../assets/svg/icons/common/info';

const schema = Yup.object().shape({
  addendums: Yup.array().min(1, "* Please select at least 1 bank"),
});

const AddendumUpdate = ({ isOpen, onClose, fetchData }) => {

  const selectedMcc = useMccStore((state) => state.selectedMcc);
  const setSelectedMcc = useMccStore((state) => state.setSelectedMcc);

  const [is_submitted, setIsSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    addendums: [],
  });

  const [addendumsOptions, setAddendumsOptions] = useState([]);

  useEffect(() => {
    if (isOpen) {
      const fetchAddeddums = async () => {
        try {
          const res = await ListOfPdfs();

          if (res.data.addendums_names.length) {
            const addeddums = res.data.addendums_names.map((item) => ({
              value: item,
              label: item,
            }));

            setAddendumsOptions(addeddums);
          }
        } catch (error) {
          console.log("error :>> ", error);
          setAddendumsOptions([]);
        }
      };
      fetchAddeddums();
    }
  }, [isOpen]);


  const onSubmit = async (values) => {
    const toastId = toast.loading('Updating...');
    let data = {
      mcc: selectedMcc,
      update_addendum: true,
      addendums: values.addendums,
    };
    const response = await mccBulkUpdate(data);
    if (response?.success) {
      fetchData();
      setSelectedMcc([]);
      toast.success("Updated successfully", { id: toastId });
      onClose();
    } else {
      toast.error("Something went wrong", { id: toastId });
      setSelectedMcc([]);
      onClose();
    }
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} header={"Add Addendums"}>
      <Formik
        enableReinitialize
        validationSchema={schema}
        onSubmit={onSubmit}
        initialValues={formData}
        validateOnBlur={false}
        validateOnChange={is_submitted}
      >
        {({
          handleSubmit,
          handleChange,
          values,
          touched,
          errors,
          setFieldValue,
          isSubmitting,
        }) => (
          <form
            onSubmit={handleSubmit}
            autoComplete="off"
            className={styles.container}
          >
            <div className={styles.alert}>
              <span className={styles.alertIcon}>
                <InfoIcon />
              </span>
              <p className={styles.alertText}>
                Only addendums of added banks are available
              </p>
            </div>

            <div className={styles.formGroup}>
              <p className={styles.formLabel}>Addendums</p>
              <TagInput
                id={"addendums"}
                name={"addendums"}
                options={addendumsOptions}
                value={values.addendums}
                onChange={(value) => {
                  setFieldValue("addendums", value);
                }}
                error={errors.addendums}
                errored={errors.addendums}
                touched={touched.addendums}
                placeholder={"Search"}
              />
            </div>

            <div className={styles.footer}>
              <ButtonIcon
                bgColor={"#FFF"}
                textColor="#254FE2"
                onClick={onClose}
                type="button"
              >
                Cancel
              </ButtonIcon>

              <ButtonIcon bgColor={"#4C70EF"} textColor="#FFF" type="submit">
                Save for {selectedMcc?.length || 0} codes
              </ButtonIcon>
            </div>
          </form>
        )}
      </Formik>
    </Modal>
  );
}

export default AddendumUpdate;